import React from 'react';
import { marketingUrl, salesUrl } from '@Constants/CommonConstants';

import './InstitutionAnonymousForm.scss';
import '../../Components/LoginAnonymousForm.scss';

function InstitutionAnonymousForm() {
  return (
    <div className="login-anonymous-form institutional-form o-els-flex-layout--center">
      <div className="institutional-form__content">
        <span className="institutional-form__content_line">
          {`New to Reaxys? `}
          <a href={marketingUrl} target="_blank" rel="noreferrer">
            Learn more
          </a>
          {` about gaining access`}
        </span>
        <span className="institutional-form__content_line">
          {`or `}
          <a href={salesUrl} target="_blank" rel="noreferrer">
            contact
          </a>
          {` our Sales Department`}
        </span>
      </div>
    </div>
  );
}

export default InstitutionAnonymousForm;
